import { proxy } from 'valtio';

function getInitialPersistenceState() {
  const href = globalThis.location?.href ?? 'ws://.';
  const url = new URL(href);

  const hashFragments = url.hash.split('?');
  const hash = hashFragments[hashFragments.length - 1] ?? '';

  const hashOverrideParams = new URLSearchParams(hash).get('localPersistenceEnabled');
  const overrideParams = url.searchParams.get('localPersistenceEnabled');
  const override = hashOverrideParams ?? overrideParams;

  return {
    localPersistenceEnabled: override !== 'false',
  };
}

export const defaultLocalPersistence = true;

export const currentLocalPersistence = proxy<{ localPersistenceEnabled: boolean }>(
  getInitialPersistenceState()
);
